export const enumPermissoesTela = {
  HOME: "HOME",
  VALIDACAO: "VALIDACAO",
  VALIDACAO_DETALHE: "VALIDACAO_DETALHE",
  PRESTADORES: "PRESTADORES",
  PRESTADORES_DETALHE: "PRESTADORES_DETALHE",
  ADMINISTRACAO: "ADMINISTRACAO",
  ADMINISTRACAO_UNIMEDS: "ADMINISTRACAO_UNIMEDS",
  ADMINISTRACAO_VALIDACOES: "ADMINISTRACAO_VALIDACOES",
  RELATORIOS: "RELATORIOS",
  RELATORIO_PRODUTIVIDADE: "RELATORIO_PRODUTIVIDADE",
  DASHBOARD: "DASHBOARD",
  CONVERSOR_XML: "CONVERSOR_XML",
  CONVERSOR_XML_LAYOUT: "CONVERSOR_XML_LAYOUT",
  CONVERSOR_XML_ARQUIVO: "CONVERSOR_XML_ARQUIVO",
  RECURSOS_PROPRIOS: "RECURSOS_PROPRIOS",
  RECURSOS_PROPRIOS_DETALHE: "RECURSOS_PROPRIOS_DETALHE"
};

export const enumPermissoesAcoes = {
  SEPARAR_CARTEIRAS_DE_UNIMEDS: "SEPARAR_CARTEIRAS_DE_UNIMEDS",
  APROVAR_ARQUIVOS: "APROVAR_ARQUIVOS",
  ENVIAR_EMAIL: "ENVIAR_EMAIL",
  VISUALIZAR_DOCUMENTOS: "VISUALIZAR_DOCUMENTOS",
  GERAR_RELATORIOS: "GERAR_RELATORIOS",
  CONSULTAR_DADOS: "CONSULTAR_DADOS",
  IMPORTAR_EXPORTAR: "IMPORTAR_EXPORTAR"
};

export const enumTelas = {
  [enumPermissoesTela.PRESTADORES]: {
    titulo: "Prestadores",
    url: "/prestadores",
    tela: "PRESTADORES"
  },
  [enumPermissoesTela.VALIDACAO]: {
    titulo: "Validação de arquivos",
    url: "/validacao",
    tela: "VALIDACAO"
  },
  [enumPermissoesTela.RELATORIOS]: {
    titulo: "Relatórios",
    url: "/relatorios",
    tela: "RELATORIOS"
  },
  [enumPermissoesTela.ADMINISTRACAO]: {
    titulo: "Administração",
    url: "/administracao",
    tela: "ADMINISTRACAO"
  },
  [enumPermissoesTela.ADMINISTRACAO_UNIMEDS]: {
    titulo: "Administração de Unimeds",
    url: "/administracao/unimeds",
    tela: "ADMINISTRACAO_UNIMEDS"
  },
  [enumPermissoesTela.ADMINISTRACAO_VALIDACOES]: {
    titulo: "Administração de Validações",
    url: "/administracao/validacoes",
    tela: "ADMINISTRACAO_VALIDACOES"
  },
  [enumPermissoesTela.DASHBOARD]: {
    titulo: "Dashboard",
    url: "/dashboard",
    tela: "DASHBOARD"
  },
  [enumPermissoesTela.CONVERSOR_XML]: {
    titulo: "Conversor XML",
    url: "/conversor-xml",
    tela: "CONVERSOR_XML"
  },
  [enumPermissoesTela.CONVERSOR_XML_LAYOUT]: {
    titulo: "Arquivos CSV Layout",
    url: "/conversor-xml/layout",
    tela: "CONVERSOR_XML_LAYOUT"
  },
  [enumPermissoesTela.CONVERSOR_XML_ARQUIVO]: {
    titulo: "Converter XML",
    url: "/conversor-xml/arquivo",
    tela: "CONVERSOR_XML_ARQUIVO"
  },
  [enumPermissoesTela.RECURSOS_PROPRIOS]: {
    titulo: "Gestão de Recursos e Serviços Próprios",
    url: "/recursos-proprios",
    tela: "RECURSOS_PROPRIOS"
  },
  [enumPermissoesTela.RELATORIO_PRODUTIVIDADE]: {
    titulo: "Produtividade Gestão de Rede (PTU A400)",
    url: "/relatorio-produtividade",
    tela: "RELATORIO_PRODUTIVIDADE"
  }
};
